import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PhoenixDirectivesModule } from '../../../directives/directives.module';
import { FuseTaskModule } from '../../content/tasks/task.module';
import { TaskWidgetComponent } from './task-widget.component';

@NgModule({
    imports: [
        CommonModule,
        FuseWidgetModule,
        FuseSharedModule,
        MatIconModule,
        MatRippleModule,
        MatButtonModule,
        MatDialogModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDividerModule,
        MatMenuModule,
        FuseTaskModule,
        PhoenixDirectivesModule,
    ],
    declarations: [
        TaskWidgetComponent,
    ],
    exports: [
        TaskWidgetComponent,
    ],
    providers: []
})
export class TaskWidgetsModule { }
